import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import LocationAddContainer from "./LocationAddContainer";
import LocationEditContainer from "./LocationEditContainer";
import LocationOverviewContainer from "./LocationOverviewContainer";

class LocationContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            activeView: null,
            locationEdit: null,
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null, locationEdit = null) {

        this.setState({
            activeView,
            locationEdit
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'add') {
            return <LocationAddContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        } else if (view === 'edit') {
            return <LocationEditContainer
                baseData={this.props.baseData}
                location={this.state.locationEdit}
                changeView={this.changeView}
            />;
        } else {
            return <LocationOverviewContainer
                baseData={this.props.baseData}
                currentCompany={this.props.baseData.companies.currentCompany}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default LocationContainer;